// extracted by mini-css-extract-plugin
module.exports = {"container":"NavButton_container_3d3ch","text":"NavButton_text_NeAU2","active":"NavButton_active_1QdiH","forbidden":"NavButton_forbidden_3Baky"};